module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAQAAABaOFzUAAAAAXNSR0IArs4c6QAAASZJREFUGBl1wb8rxHEcx/GXzWCgTFcolEmJ8gcoMjBZFULKdJMYjAy3SESpy4IsiNEiYdGlu0Ed7+fny1GnIxaL7ePj8ut0Hg/95vo4I8MuzSrHmuyQPFNRC1u8sOQrVIpFnti6rFIRHZYmb2P6Qi8Fd3zdphIMkyeVjUm6buTNJlUWJ1xIskFe9ck2OFVgM+5AwU01V5JyNVG3irIxPN56JPbwClycgqSbSupUZJuWZIKUxBp3CvB4SeTwblqBPWPs4CXmuFNAwg4lkcG7uGT9eNYsiWeIWbx+0EVGgZtnXwEJW3ADrCuIWtyypKibrP7hWnmQdFVL3jZVhqsnx7Y+RA2cc8+4StgKj6zqh41ilqZLRS5OjqOoU3+xyC1T1m5JzI3o2zv2gbhfyO2GVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smAi.png
// module id = yFru
// module chunks = 1